import { render, staticRenderFns } from "./EntryArrowControls.vue?vue&type=template&id=1b1c3646&scoped=true&"
import script from "./EntryArrowControls.vue?vue&type=script&lang=js&"
export * from "./EntryArrowControls.vue?vue&type=script&lang=js&"
import style0 from "./EntryArrowControls.scss?vue&type=style&index=0&id=1b1c3646&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c3646",
  null
  
)

export default component.exports